export const MARK_PANEL_EVENT = {
  contextIconClicked: 'MARK Context Icon Clicked',
  floatingButtonClicked: 'MARK Floating Button Clicked',
  panelOpened: 'MARK Panel Opened',
  panelClosed: 'MARK Panel Closed',
  chatStarted: 'MARK Chat Started',
  responseReceived: 'MARK Response Received',
  responseFailed: 'MARK Response Failed',
} as const satisfies Record<string, string>;

export type MarkPanelEventName =
  (typeof MARK_PANEL_EVENT)[keyof typeof MARK_PANEL_EVENT];

export type MarkChatAnalyticsSurface = 'markPage' | 'monitoring';

export type MarkPanelResponseRequestType =
  | 'send'
  | 'retry'
  | 'regenerate'
  | 'edit';

export type MarkPanelResponseErrorType = 'usageLimit' | 'generic';
